import { compose, map, path, pathOr } from 'ramda'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { selectToken } from '@/app/module/auth/store/selectors'
import { getCustomFields } from '@/app/module/custom-fields/store/actions'
import { getGroupContacts } from '@/app/module/groups/store/actions'
import { getSegmentContacts } from '@/app/module/segments/store/actions'
import { selectOrgId, selectUserId, selectUserTimezone } from '@/app/module/user/store/selectors'
import config from '@/config'

import Contacts from './component'
import {
  deleteContacts,
  downloadContacts,
  getContacts,
  getContactsTableHeaders,
  navigateContacts,
  saveContactsTableHeaders,
  setContactsPageSize,
} from './store/actions'
import {
  selectContactsItemConfig,
  selectContactsValues,
  selectHeaders,
  selectNewContactValues,
  selectOrdered,
} from './store/selectors'

const GROUP_TYPE = pathOr({}, ['modules', 'groups', 'type'], config)
const SEGMENT_TYPE = pathOr({}, ['modules', 'segments', 'type'], config)

export const pageSizeValues = compose(
  map((val) => ({ label: val, value: val })),
  path(['modules', 'contacts', 'pageSize', 'values']),
)(config)

const getContactsAction =
  ({ token, orgId, query }) =>
  (dispatch) => {
    if (query.filter && query.filter.name === GROUP_TYPE.name) {
      return dispatch(getGroupContacts({ token, orgId, groupId: query.filter.value, query }))
    }
    if (query.filter && query.filter.name === SEGMENT_TYPE.name) {
      return dispatch(getSegmentContacts({ token, orgId, segmentId: query.filter.value, query }))
    }
    return dispatch(getContacts({ token, orgId, query }))
  }

const selector = ({ user, contacts, customFields, utils }) => ({
  root: 'contacts',
  error: {
    ...customFields.error,
    ...contacts.list.error,
  },
  item: {
    id: contacts.item.data.id,
    error: pathOr({}, ['item', 'error', 'fields'], contacts),
  },
  token: selectToken(),
  orgId: selectOrgId({ user }),
  userId: selectUserId({ user }),
  loading:
    !contacts.list.initialized ||
    contacts.list.loading ||
    user.details.loading ||
    user.organization.loading ||
    customFields.loading,
  loadingItems: pathOr([], ['list', 'data', 'loadingItems'], contacts),
  data: selectContactsValues({ contacts, customFields }),
  values: selectNewContactValues({ contacts }),
  specs: selectContactsItemConfig({ user, customFields, utils }),
  ordered: selectOrdered({ contacts }),
  headers: selectHeaders({ customFields, contacts }),
  total: pathOr(0, ['list', 'data', 'total'], contacts),
  orgTotal: pathOr(0, ['list', 'data', 'orgTotal'], contacts),
  pageSizeValues,
  personalizationList: {},
  timezone: selectUserTimezone({ user, utils }),
})

const dispatcher = (dispatch) =>
  bindActionCreators(
    {
      getContacts: getContactsAction,
      deleteItems: deleteContacts,
      downloadItems: downloadContacts,
      navigate: navigateContacts,
      setPageSize: setContactsPageSize,
      getCustomFields,
      getContactsTableHeaders,
      saveContactsTableHeaders,
    },
    dispatch,
  )

export default connect(selector, dispatcher)(Contacts)
